import { Styled } from './AppMain.styles';

// App Main Component
function AppMain({ children }) {
  return <Styled.AppMain>{children}</Styled.AppMain>;
}

export { AppMain };
